import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function FAQPage() {
  const location = useLocation();
  const [expandedIds, setExpandedIds] = useState({});

  const faqs = [
    {
      id: "kongre-tarih",
      question:
        "XII. Zekâ ve Yetenek Kongresi ne zaman ve nerede gerçekleşecek?",
      answer:
        "XII. Zekâ ve Yetenek Kongresi, 7 Kasım 2026 tarihinde Ankara'da düzenlenecektir.",
    },
    {
      id: "atolye-tarih",
      question:
        "XII. Zekâ ve Yetenek Kongresi kapsamında düzenlenecek atölyeler ne zaman ve nerede gerçekleştirilecek?",
      answer:
        "Atölye çalışmaları, 8 Kasım 2026 tarihinde Ankara'da, ODTÜ Eğitim Fakültesi'nde gerçekleştirilecektir.",
    },
    {
      id: "kimler-katilabilir",
      question: "Kongreye kimler katılım sağlayabilir?",
      answer:
        "Kongremiz, zekâ ve yetenek konularına ilgi duyan herkese açıktır. Öğrenciler, akademisyenler, eğitimciler, psikologlar, rehber öğretmenler ve konuya ilgi duyan tüm profesyoneller katılabilir.",
    },
    {
      id: "katilim-ucreti",
      question: "Kongre katılım ücreti ne kadar ve erken kayıt avantajı nedir?",
      answer:
        "Erken kayıt fırsatı kapsamında kongre katılım ücreti 950 TL yerine 700 TL'dir. Bu fırsat, 31 Ağustos 23.59'a kadar geçerlidir.",
    },
    {
      id: "odtu-indirim",
      question: "ODTÜ öğrencileri için indirim imkânı var mı?",
      answer: (
        <>
          <span style={{ display: "block", marginBottom: 8 }}>
            Evet, ODTÜ'de örgün öğretime devam eden katılımcılara kongre ana
            kayıt ücreti üzerinden%50 indirim uygulanacaktır.
            Bu indirim yalnızca aktif öğrenciler için geçerlidir; mezunlar
            indirimden yararlanamaz.
          </span>

          <span style={{ display: "block", marginBottom: 8 }}>
            İndirimden faydalanabilmek için sisteme ODTÜ uzantılı (
            @metu.edu.tr) e-posta adresinizle kayıt olmanız
            gerekmektedir. Kayıt işleminizin ardından indirimden yararlanabilmek için aynı e-posta adresi
            üzerinden kongre@tzv.org.tr adresine mail gönderiniz.
          </span>

          <span style={{ display: "block" }}>
            İndirim kontenjanı 100 kişi ile sınırlıdır.
          </span>
        </>
      ),
    },
    {
      id: "belge",
      question: "Etkinliğe katıldığımda belge alabilecek miyim?",
      answer:
        "Etkinlik sonrasında katılım belgesi düzenlenecektir. Belgelerinizi profil sayfanızdaki 'Belgelerim' butonu aracılığıyla indirebilirsiniz.",
    },
    {
      id: "toplu-odeme",
      question: "Toplu katılım ödemesi nasıl yapılır ve süreç nasıl işler?",
      answer:
        "Toplu ödeme yapmak isteyenler Toplu Ödeme sekmesini kullanabilirler.Toplu ödeme işleminin gerçekleştirilebilmesi için ödeme yapılacak kişilerin kongreye kayıtlı e-posta adreslerinin sistemde kayıtlı olması gerekmektedir.Kurumsal ödeme talebiniz bulunuyorsa, lütfen bağlı bulunduğunuz kurum ile iletişime geçiniz.",
    },
  ];

  useEffect(() => {
    const targetId = location.hash?.replace("#", "");
    if (!targetId) return;
    setExpandedIds((prev) => ({ ...prev, [targetId]: true }));
    const el = document.getElementById(targetId);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [location.hash]);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {faqs.map((faq) => (
        <Accordion
          key={faq.id}
          id={faq.id}
          expanded={!!expandedIds[faq.id]}
          onChange={(_, isExpanded) =>
            setExpandedIds((prev) => ({ ...prev, [faq.id]: isExpanded }))
          }
          sx={{
            mb: 2,
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            "&:before": {
              display: "none",
            },
            borderRadius: "8px !important",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "rgba(48, 43, 99, 0.03)",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "rgba(48, 43, 99, 0.06)",
              },
            }}
          >
            <Typography
              sx={{
                fontWeight: "600",
                color: "#302b63",
                textAlign: "start",
              }}
            >
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ color: "#444", textAlign: "start" }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
  );
}
